// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .sbscr .bell-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    background-color: var(--primary-color);\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n  }\n  .root .sbscr .bell-icon__svg {\n    fill: var(--secondary-color);\n  }\n", ""]);
// Exports
module.exports = exports;
